import isInteger from 'lodash/isInteger';

const CURRENCY_MAPPING: Record<string, (value: number, options?: Intl.NumberFormatOptions) => string> = {
    USD: (price: number, options?: Intl.NumberFormatOptions) =>
        price.toLocaleString('en-US', { style: 'currency', currency: 'USD', ...options }),
    EUR: (price: number, options?: Intl.NumberFormatOptions) =>
        price.toLocaleString('en-US', { style: 'currency', currency: 'EUR', ...options }),
    RUB: (price: number, options?: Intl.NumberFormatOptions) =>
        price.toLocaleString('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            maximumFractionDigits: isInteger(price) ? 0 : 2,
            ...options,
        }),
};

export const formatPrice = (
    price: number | string,
    code: string = 'RUB',
    options?: Intl.NumberFormatOptions
): string | undefined => CURRENCY_MAPPING[code]?.(Number(price), options);
